import { Dayjs } from 'dayjs';
import { FirmwareBundle } from './firmware-bundle';
import { SoftwareArtifactReleaseType } from './software-artifact-release-type';
import { BaseModel } from '../basemodel';

export enum SoftwareArtifactStatus {
  PREPARED = 'PREPARED',
  HIDDEN = 'HIDDEN',
  RELEASED = 'RELEASED',
  WITHDRAWN = 'WITHDRAWN',
}

export class SoftwareArtifact extends BaseModel {
  version?: string;

  buildNumber?: number;

  changelog?: string;

  size?: number;

  branchName?: string;

  status: SoftwareArtifactStatus = SoftwareArtifactStatus.PREPARED;

  releaseType?: SoftwareArtifactReleaseType;

  url?: string;

  releaseDate?: Dayjs = undefined;

  creationDate?: Dayjs = undefined;

  /** Optional firmware bundle details when this artifact is a firmware bundle. */
  firmwareBundle?: FirmwareBundle;

  firmwareBundles: FirmwareBundle[] = [];
}
